module.exports = __webpack_public_path__ + "static/assets/cedd47a7421756f652e77ef67b697e38.png";